import React from 'react';
import { makeStyles } from '@material-ui/core';

import { FormControlLabel, Radio, RadioGroup } from '@ha/dsl';

export interface Option<T extends string = string> {
  value: T;
  title: string | React.ReactNode;
  testLocator?: string;
}

interface Props {
  value: string | null;
  onChange: (value: string) => void;
  options: Option[];
  name?: string;
  layout?: 'horizontal' | 'vertical';
}

const useStyles = makeStyles(() => ({
  // to reset global styles set by app.bundle.css
  formControlLabel: {
    marginBottom: 0,
    marginRight: 0,
  },
  label: {
    width: '100%',
  },
}));

const CommonRadioFilter: React.FC<Props> = ({
  value,
  onChange,
  options,
  name,
  layout = 'vertical',
}) => {
  const classes = useStyles();

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const toggledOption = event.target.value;

      onChange(toggledOption);
    },
    [onChange],
  );

  return (
    <RadioGroup
      row={layout === 'horizontal'}
      value={value}
      name={name}
      onChange={handleChange}
    >
      {options.map(({ value: optionValue, title, testLocator }) => (
        <FormControlLabel
          className={classes.formControlLabel}
          classes={{
            label: classes.label,
          }}
          key={optionValue}
          control={<Radio color="primary" data-test-locator={testLocator} />}
          value={optionValue}
          label={title}
        />
      ))}
    </RadioGroup>
  );
};

export default CommonRadioFilter;
